import { SITE_URL } from '../config/appLinks'

/**
 * Which pages search engines may index, and each page's canonical URL.
 *
 * An allowlist: a page is indexable only if it is listed here, so a removed
 * route, a 404 or a new private screen is never indexed by accident.
 * public/sitemap.xml lists the same exact paths.
 */
export const INDEXABLE_PATHS = ['/', '/shop', '/restaurants', '/groceries', '/contact', '/terms', '/privacy']
const INDEXABLE_PREFIXES = ['/vendor-shop/', '/product-details/', '/category/', '/flash-sale/']

// Customer-only pages: not indexed, and their links are not followed.
const PRIVATE_PREFIXES = ['/checkout', '/cart', '/account', '/orders', '/order-tracking', '/order-success', '/notifications', '/notification-settings', '/addresses', '/payment', '/complete-profile', '/otp-verification', '/reset-password', '/forgot-password']

const normalise = pathname => (pathname.length > 1 ? pathname.replace(/\/+$/, '') : pathname) || '/'

export const robotsFor = pathname => {
  const p = normalise(pathname)
  if (PRIVATE_PREFIXES.some(x => p === x || p.startsWith(x + '/'))) return 'noindex, nofollow'
  if (INDEXABLE_PATHS.includes(p) || INDEXABLE_PREFIXES.some(x => p.startsWith(x) && p.length > x.length)) return 'index, follow'
  return 'noindex, follow'
}

/** The page's own URL without query or hash (index.html ships the home page's). */
export const canonicalFor = pathname => `${SITE_URL}${normalise(pathname)}`
